import React, { memo, useEffect, useRef, useState } from 'react';
import { Card, Tab } from 'react-bootstrap';
import { useClickAway } from 'react-use';
import { useGetRequest } from '../../../hooks/useGetRequest';
import { MEDICINE_TYPES_SHORTS, getMedicineIcon } from '../../../utils/helpers';
import FormatsAndType from '../partials/rx/formatsAndType';
import Information from '../partials/rx/information';
import SimilarMedicine from '../partials/rx/similarMedicine';
import Suggestions from '../partials/suggestions';
import TabNavMedicineDefault from '../partials/tabNavMedicineDefault';
import SuggestionsGeneric from '../partials/suggestionsGeneric';

const MedicineScheduleListModal = ({
  item,
  // removeSchedule,
  // duplicateSchedule,
  handleDefaultData,
  setIsMedicineDefault,
  // handleSelectedMedicine,
  // showBrandListModal,
  setShowBrandListModal,
  setShowScheduleListModal,
}) => {
  const [indications, setIndications] = useState(null);
  const ref = useRef(null);

  const { isLoading, refetch: getMedicineIndication } = useGetRequest(
    `getMedicineIndication-${item?.id}`,
    `medicine-indications/${item?.medicineIndicationId}`,
    (data) => {
      const banglaResult = Object.keys(data)
        .filter((key) => key.endsWith('Bn') && data[key].details !== '')
        .map((key) => data[key])
        .sort((a, b) => a.sort - b.sort);

      const englishResult = Object.keys(data)
        .filter((key) => !key.endsWith('Bn') && data[key].details !== '')
        .map((key) => data[key])
        .sort((a, b) => a.sort - b.sort);
      const result = { banglaResult, englishResult };
      setIndications({ ...result });
    },
    (e) => {
      console.log(e);
    },
  );

  useClickAway(ref, (e) => {
    setShowScheduleListModal(false);
    setShowBrandListModal?.(false);
  });

  useEffect(() => {
    if (item?.medicineIndicationId) {
      getMedicineIndication();
    }
  }, [item?.medicineIndicationId]);

  return (
    <Card className="medicine-default testt-modal" ref={ref}>
      <Card.Header>
        <div className="medicine-name-and-icon">
          <img
            src={getMedicineIcon(MEDICINE_TYPES_SHORTS[item.type])}
            alt="Tablet"
            className="pr-2"
            width={40}
            height={36}
          />
          <span className="medicine-name">
            {MEDICINE_TYPES_SHORTS[item.type]} {item?.name}
          </span>
          <span>
            <i
              onClick={() => setShowScheduleListModal(false)}
              className="fa fa-times-circle"
              aria-hidden="true"
            ></i>
          </span>
        </div>
        <div className="generic-name">{item?.brandName}</div>
      </Card.Header>
      <Card.Body>
        <Tab.Container id="left-tabs" defaultActiveKey="suggestions">
          {/* <TabNavMedicineDefault /> */}
          {/* <Tab.Content>
            <Tab.Pane eventKey="suggestions" className="add-scroll"> */}
          <div class="add-scroll">
            <SuggestionsGeneric
              medicine={item}
              handleDefaultData={handleDefaultData}
            />
          </div>
          {/* </Tab.Pane> */}
          {/* <Tab.Pane
              eventKey="similarMedicines"
              className="add-scroll similar-medicine"
            >
              <SimilarMedicine
                item={item}
                handleSelectedMedicine={handleSelectedMedicine}
              />
            </Tab.Pane> */}
          {/* <Tab.Pane eventKey="formatsAndType" className="formats-type">
              <FormatsAndType
                medicine={item}
                removeSchedule={removeSchedule}
                duplicateSchedule={duplicateSchedule}
                handleSelectedMedicine={handleSelectedMedicine}
              />
            </Tab.Pane>
            <Tab.Pane eventKey="information" className="add-scroll information">
              <Information indications={indications} />
            </Tab.Pane> */}
          {/* </Tab.Content> */}
        </Tab.Container>
      </Card.Body>
      {/* <Card.Footer>
        Manufacturer: <span>{item?.companyName}</span>
      </Card.Footer> */}
    </Card>
  );
};

export default memo(MedicineScheduleListModal);
